import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    lastUpdated: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: theme.spacing(3)
    },
    eulaTitle: {
        fontWeight: 350,
        padding: theme.spacing(5, 0)
    },
    eulaBody: {
        '& h1, & h2, & h3, & h4, & h5': {
            color: theme.palette.common.white,
            margin: theme.spacing(3, 0)
        },
        '& h1': theme.overrides.MuiTypography.h1,
        '& h2': theme.overrides.MuiTypography.h2,
        '& h3': {
            ...theme.overrides.MuiTypography.h3,
            [theme.breakpoints.up('lg')]: {
                fontSize: theme.typography.pxToRem(22),
                '&> span': {
                    fontSize: theme.typography.pxToRem(22)
                }
            }
        },
        '& h4': {
            ...theme.overrides.MuiTypography.h4,
            fontWeight: 'normal',
            [theme.breakpoints.up('lg')]: {
                fontSize: theme.typography.pxToRem(20),
                '&> span': {
                    fontSize: theme.typography.pxToRem(20)
                }
            }
        },
        '& h5': {
            ...theme.overrides.MuiTypography.h5,
            fontSize: `${theme.typography.pxToRem(16)} !important`,
            '&> span': {
                fontSize: `${theme.typography.pxToRem(16)} !important`
            }
        },
        '& a': {
            color: theme.palette.text.secondary,
            fontWeight: 'normal',
            borderBottom: `1px solid ${theme.palette.text.secondary}`,
            '&:hover': {
                textDecoration: 'none',
                color: theme.palette.common.white
            },
            '&:visited': {
                color: theme.palette.text.secondary
            }
        },
        '& ol': {
            listStyleType: 'lower-alpha'
        }
    }
}));

export default useStyles;
